import { render, staticRenderFns } from "./NsProductCard.vue?vue&type=template&id=d44b85f2&"
import script from "./NsProductCard.vue?vue&type=script&lang=js&"
export * from "./NsProductCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports